import {ConfigurationProfile, UIConfiguration, UISections} from "@/components/device/configuration/types";
import * as _ from "lodash";
import {SelectOption} from "@/types/core";

export class ConfigurationProfileHelper {
  private readonly _deviceConfigurationProfile:ConfigurationProfile;

  constructor(configurationProfile:ConfigurationProfile) {
    this._deviceConfigurationProfile = configurationProfile;
  }


  get deviceConfigurationProfile(): ConfigurationProfile {
    return this._deviceConfigurationProfile;
  }

  public getIdsSortedByPosition():string[] {
    return _.map(_.sortBy(_.values(this._deviceConfigurationProfile), 'position'),
      entity => this.toHex(entity.id));
  }

  public getIdsAsNumbers(configurationProfile:ConfigurationProfile):number[] {
    return _.map(_.values(configurationProfile), e => e.id);
  }

  public isValueInRange(id:string, configuration:UIConfiguration):boolean {

    if ( this._deviceConfigurationProfile[id] === undefined ) { //ignore non-defined in profile parameters
      return true;
    }

    if ( this._deviceConfigurationProfile[id].type === 'option' ) {
      return configuration[id]!.value !== undefined
        && configuration[id]!.value !== ''
        && configuration[id]!.value !== null;
    }
    if ( this._deviceConfigurationProfile[id].type === 'number' ) {
      if ( this._deviceConfigurationProfile[id].canBeZero && configuration[id]!.value === 0 ) {
        return true;
      }

      const comp = configuration[id]!.value >= (this._deviceConfigurationProfile[id].min as number)
        && configuration[id]!.value <= (this._deviceConfigurationProfile[id].max as number);
      return comp;
    }
    if ( this._deviceConfigurationProfile[id].type === 'string') {
      return configuration[id]!.value.length <= (this._deviceConfigurationProfile[id].maxStringLength as number);
    }
    if ( this._deviceConfigurationProfile[id].type === 'toggle' ) {
      const value = configuration[id]!.value;
      const options = this._deviceConfigurationProfile[id].options;

      if(value === undefined) { // ignore
        return true;
      }

      return (value !== '' && value !== null) &&
        (options !== undefined && options.some((x) => x.value === value));
    }

    if ( this._deviceConfigurationProfile[id].type === 'checkbox-group') {
      return true;
    }
    return false;
  }

  public getDeviceUIConfiguration():UIConfiguration {
    const uiConfiguration:UIConfiguration = {};
    _.forEach(_.keys(this._deviceConfigurationProfile), id => {
      uiConfiguration[id] = {
        id: parseInt(id, 16),
        value: this._deviceConfigurationProfile[id].type === 'option' ?
          (this._deviceConfigurationProfile[id].options as SelectOption[])[0].value :
          this._deviceConfigurationProfile[id].defaultValue ?
            this._deviceConfigurationProfile[id].defaultValue :
            this._deviceConfigurationProfile[id].min,
        edit: false,
      }
    });
    return uiConfiguration;
  }

  public getUISections():UISections {
    const uiSection:UISections = {};
    const idWithSections:string[] = _.filter(_.keys(this._deviceConfigurationProfile),
      id => this._deviceConfigurationProfile[id].newUiSection) as string[];

    let i = 0;
    _.forEach(idWithSections, id => {
      let expanded = false;
      if (i === 0) {
        expanded = true;
      }
      uiSection[id] = {
        id: parseInt(id, 16),
        expanded,
      };
      i++;
    });
    return uiSection;
  }

  private toHex(d:number) {
    return  "0x" + ("0"+(d.toString(16))).slice(-2);
  }
}
